export default __webpack_public_path__ + "50fb5a58038ded649e837fcb078e0a7d.svg";